export default "__VITE_ASSET__BpLrzxh5__"